export default __webpack_public_path__ + "static/media/backtop.d28f2476.png";